import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import { clearParams } from '~/shared';
import {
  BuscaPatrocinadaKeywordsDTO,
  BuscaPatrocinadaKeywordsResponse,
} from '~/types/keywordPerformance';

export const GET_BUSCA_PATROCINADA_KEYWORDS_QUERY_KEY =
  'GET_BUSCA_PATROCINADA_KEYWORDS';

function getBuscaPatrocinadaKeywords(params: BuscaPatrocinadaKeywordsDTO) {
  const clearedParams = clearParams(params as Record<string, unknown>);
  return serviceApi.get<BuscaPatrocinadaKeywordsResponse>(
    '/RelatorioBuscaPatrocinada/keywords',
    { params: clearedParams }
  );
}

export function useGetBuscaPatrocinadaKeywords(
  params: BuscaPatrocinadaKeywordsDTO
) {
  return useQuery({
    queryKey: [GET_BUSCA_PATROCINADA_KEYWORDS_QUERY_KEY, params],
    queryFn: () => getBuscaPatrocinadaKeywords(params),
    select: data => data.data,
    placeholderData: keepPreviousData,
  });
}
